"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BUTTON_OPERATION_KEYS = exports.convertToOptions = exports.SEGMENT = exports.ICON_POSITION = exports.BUTTON_OPERATION = exports.LABEL_SIZE = exports.BUTTON_HEIGHT = exports.BUTTON_WIDTH = exports.BUTTON_LETTER_SPACING = exports.BUTTON_TEXT_TRANSFORM = exports.BUTTON_FONT = exports.BUTTON_COLOR = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.log-utils");

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.common");

var _gerenciatdUtils3 = require("@bit/gerenciatd.utils.tagging");

var _Spin = _interopRequireDefault(require("./Spin"));

require("./button.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint react/button-has-type: 0 */

/* it is necesarry because buttonType come from props */
var COMPONENT_NAME = 'Button';
var BUTTON_COLOR = {
  GREEN: 'green',
  GREEN_REVERSE: 'green_reverse',
  GREEN_MEDIUM: 'green_medium',
  GREEN_LIGHT: 'green-light',
  BLUE: 'blue',
  BLUE_LIGHT: 'blue_light',
  BLUE_REVERSE: 'blue_reverse',
  BLUE_DARK: 'blue_dark',
  BLUE_DARK_REVERSE: 'blue_dark_reverse',
  WHITE_BLUE: 'white_blue',
  GREY: 'grey',
  GREY_REVERSE: 'grey_reverse',
  GREY5: 'grey5',
  GREY_REVERSE5: 'grey_reverse5',
  RED: 'red',
  RED_REVERSE: 'red_reverse',
  HEADER: 'header',
  HEADER_REVERSE: 'header_reverse',
  HEADER_DIFFERENTIATED: 'header_differentiated',
  ORANGE: 'orange',
  PURPLE: 'purple',
  WHITE: 'white',
  WHITE_REVERSE: 'white_reverse'
};
exports.BUTTON_COLOR = BUTTON_COLOR;
var BUTTON_FONT = {
  REGULAR_FONT: 'regular',
  BOLD_FONT: 'bold'
};
exports.BUTTON_FONT = BUTTON_FONT;
var BUTTON_TEXT_TRANSFORM = {
  INITIAL: 'initial',
  UPPERCASE: 'uppercase'
};
exports.BUTTON_TEXT_TRANSFORM = BUTTON_TEXT_TRANSFORM;
var BUTTON_LETTER_SPACING = {
  DEFAULT: 'default',
  EMP: 'emp'
};
exports.BUTTON_LETTER_SPACING = BUTTON_LETTER_SPACING;
var BUTTON_WIDTH = {
  SHORT: 'short',
  DOUBLE: 'double',
  MEDIUM: 'medium',
  LARGE: 'large',
  LIQUID: 'liquid',
  FULL: 'full'
};
exports.BUTTON_WIDTH = BUTTON_WIDTH;
var BUTTON_HEIGHT = {
  LARGE: 'large',
  // 48
  REGULAR: 'regular',
  // 43
  MEDIUM: 'medium',
  // 32
  SMALL: 'small' // 30

};
exports.BUTTON_HEIGHT = BUTTON_HEIGHT;
var LABEL_SIZE = {
  DEPENDS_SIZE_SELECTED: 'depends_size_selected',
  LARGE: 'large',
  // 48
  REGULAR: 'regular',
  // 43
  MEDIUM: 'medium',
  // 32
  SMALL: 'small' // 30

};
exports.LABEL_SIZE = LABEL_SIZE;
var BUTTON_OPERATION = {
  LOADING: 'loading',
  SUCCESS: 'success',
  FAILURE: 'failure',
  NO: 'no'
};
exports.BUTTON_OPERATION = BUTTON_OPERATION;
var ICON_POSITION = {
  LEFT: 'left',
  RIGHT: 'right'
};
exports.ICON_POSITION = ICON_POSITION;
var SEGMENT = {
  PARTICULARES: 'particulares',
  EMPRESAS: 'empresas',
  GP: 'gp',
  EMP: 'emp'
};
exports.SEGMENT = SEGMENT;

var convertToOptions = function convertToOptions(optionsObject) {
  var keys = Object.keys(optionsObject);
  return keys.map(function (key) {
    return optionsObject[key];
  });
};

exports.convertToOptions = convertToOptions;
var BUTTON_OPERATION_KEYS = Object.keys(BUTTON_OPERATION);
/**
 * PureComponent component to draw a Button
 * @param {string} color behave as theme, it must be one of: BUTTON_COLOR
 * @param {string} size its and object like: { w: BUTTON_WIDTH, h: BUTTON_HEIGHT}
 * @param {string} label label that appears inside the button
 * @param {string} labelSize indicates label's font-size one of  LABEL_SIZE
 * @param {string} operation svg behaviour one of: BUTTON_OPERATION
 * @param {string} link destination link after click
 * @param {string} taggingInfo object for tagging
 * @param {string} disable disable the button, no onClick posible either link
 * @param {string} className own css classname for styling
 * @returns {JSX} Component JSX.
 */

exports.BUTTON_OPERATION_KEYS = BUTTON_OPERATION_KEYS;

var Button = /*#__PURE__*/function (_PureComponent) {
  _inherits(Button, _PureComponent);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "setLabelAnimation", function (operation) {
      if (operation === BUTTON_OPERATION.NO) {
        return 'show';
      }

      if (operation === BUTTON_OPERATION.LOADING) {
        return 'hidden';
      }

      return 'fade';
    });

    _defineProperty(_assertThisInitialized(_this), "buttonSizeCss", function (size) {
      var w = size.w,
          h = size.h;

      if (!w) {
        w = BUTTON_WIDTH.MEDIUM;
      }

      if (!h) {
        h = BUTTON_HEIGHT.REGULAR;
      }

      return {
        button: " button_width--".concat(w, " button_height--").concat(h),
        buttongap: " buttongap_width--".concat(w)
      };
    });

    _defineProperty(_assertThisInitialized(_this), "setLabelSizeCss", function (size) {
      return " button_label--".concat(size);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (event) {
      var onClick = _this.props.onClick;
      var e = event || evt;

      if (e.button === 1) {
        if (onClick) {
          onClick();
          return true;
        }
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "getSegment", function () {
      var segment = _this.props.segment;
      /* TRANSFORM segment when PARTICULARES OR EMPRESAS */

      switch (segment) {
        case 'empresas':
        case 'emp':
          segment = 'emp';
          break;

        case 'particulares':
        default:
          segment = 'gp';
          break;
      }

      return segment;
    });

    _defineProperty(_assertThisInitialized(_this), "renderButtonContent", function (props) {
      var svgComponent = props.svgComponent,
          size = props.size,
          label = props.label,
          operation = props.operation,
          color = props.color,
          labelSize = props.labelSize,
          iconPosition = props.iconPosition;
      /* check if size has w and  */

      var mySize = _objectSpread({
        w: BUTTON_WIDTH.MEDIUM,
        h: BUTTON_HEIGHT.REGULAR
      }, size);
      /* APPEARANCE */


      var labelSizeCss = _this.setLabelSizeCss(mySize.h);

      if (labelSize && labelSize !== LABEL_SIZE.DEPENDS_SIZE_SELECTED) {
        labelSizeCss = _this.setLabelSizeCss(labelSize);
      }

      var labelAnimationClass = _this.setLabelAnimation(operation);

      var loaderSettings = {
        type: 'TailSpin',
        color: 'white',
        sizeLoader: mySize
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "globalContent",
        children: [iconPosition === ICON_POSITION.RIGHT && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: "button_label ".concat(labelAnimationClass, " ").concat(labelSizeCss),
          children: [label, svgComponent && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "button_label_svg",
            children: svgComponent
          })]
        }), iconPosition === ICON_POSITION.LEFT && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: "button_label ".concat(labelAnimationClass, " ").concat(labelSizeCss),
          children: [svgComponent && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "button_label_svg",
            children: svgComponent
          }), label]
        }), operation !== BUTTON_OPERATION.NO && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Spin["default"], {
          operation: operation,
          className: color,
          size: loaderSettings.sizeLoader
        })]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderButton", function (props) {
      var size = props.size,
          buttonType = props.buttonType,
          className = props.className,
          disable = props.disable,
          color = props.color,
          font = props.font,
          border = props.border,
          textTransform = props.textTransform;
      /* check if size has w and  */

      var segment = _this.getSegment();

      var mySize = _objectSpread({
        w: BUTTON_WIDTH.MEDIUM,
        h: BUTTON_HEIGHT.REGULAR
      }, size);
      /* APPEARANCE */


      var customClassName = className ? "".concat(className, " ") : '';
      var colorCss = "button button--".concat(color, " ").concat(disable ? "button--".concat(color, "-").concat(segment, "--disable") : "button--".concat(color, "-").concat(segment, "--enable"));
      var customCss = "font_".concat(segment, "--").concat(font, " border--").concat(border, " textTransform--").concat(textTransform);

      var widthCss = _this.buttonSizeCss(mySize);

      return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: buttonType,
        className: "".concat(customClassName, " buttongap ").concat(widthCss.buttongap, " ").concat(colorCss).concat(widthCss.button, " ").concat(customCss),
        tabIndex: "-1",
        onMouseDown: _this.handleMouseDown,
        children: _this.renderButtonContent(props)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderButtonAndContent", function (props) {
      var onClick = props.onClick,
          link = props.link,
          taggingInfo = props.taggingInfo,
          disable = props.disable,
          className = props.className,
          label = props.label,
          color = props.color,
          forceExternal = props.forceExternal,
          size = props.size,
          buttonType = props.buttonType,
          target = props.target,
          font = props.font,
          border = props.border,
          textTransform = props.textTransform;

      var segment = _this.getSegment();
      /* check if size has w and  */


      var mySize = _objectSpread({
        w: BUTTON_WIDTH.MEDIUM,
        h: BUTTON_HEIGHT.REGULAR
      }, size);

      var customClassName = className ? "".concat(className, " ") : '';
      var colorCss = "button button--".concat(color, "-").concat(segment, " ").concat(disable ? "button--".concat(color, "-").concat(segment, "--disable") : "button--".concat(color, "-").concat(segment, "--enable"));
      var customCss = "font_".concat(segment, "--").concat(font, " border--").concat(border, " textTransform--").concat(textTransform);

      var widthCss = _this.buttonSizeCss(mySize);

      if ((onClick || link) && taggingInfo && !disable && buttonType !== 'submit') {
        /* COMPLETING TAGGINGINFO IF NEEDED */
        if (!taggingInfo.componentContent) {
          taggingInfo.componentContent = _gerenciatdUtils3.BUTTON_CONTENT.DEFAULT;
        }

        if (!taggingInfo.componentName) {
          taggingInfo.componentName = COMPONENT_NAME;
        }

        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents["default"], {
          taggingInfo: taggingInfo,
          link: link,
          ariaLabel: label,
          onClick: onClick,
          forceExternal: forceExternal,
          className: "".concat(customClassName, " buttongap ").concat(widthCss.buttongap, " ").concat(colorCss).concat(widthCss.button, " ").concat(customCss, " ButtonCL"),
          target: target,
          children: _this.renderButtonContent(props)
        });
      }

      return _this.renderButton(props);
    });

    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var myProps = (0, _gerenciatdUtils2.setUpPropsByDevice)(this.props);
      var operation = myProps.operation;
      var taggingInfo = myProps.taggingInfo;
      /* Cheeckings */

      var operationSendExist = false;
      BUTTON_OPERATION_KEYS.forEach(function (opKey) {
        if (!operationSendExist && operation === BUTTON_OPERATION[opKey]) {
          operationSendExist = true;
        }
      });

      if (!operationSendExist) {
        (0, _gerenciatdUtils.warnLog)('[Button]: operation sended is not defined, prop has been reset to BUTTON_OPERATION.NO', 'button-operation');
        operation = BUTTON_OPERATION.NO;
      }

      if (!taggingInfo) {
        (0, _gerenciatdUtils.errorLog)('[Button]: taggingInfo is not present');
        return null;
      }

      return this.renderButtonAndContent(myProps);
    }
  }]);

  return Button;
}(_react.PureComponent);

Button.propTypes = {
  /**
   * {
   *  "info": "Texto que aparecerá dentro del componente",
   *  "kind": "both",
   *  "beautifulName": "Texto"
   * }
   */
  label: _propTypes["default"].string,

  /**
   * {
   *  "info": "Tipo de botón, sirve para cumplimentar la propiedad type del dom para este elemento: submit, button o reset",
   *  "kind": "playground",
   *  "beautifulName": "Tipo"
   * }
   */
  buttonType: _propTypes["default"].oneOf(['submit', 'button', 'reset']),

  /**
   * {
   *  "info": "Tipo de fuente del texto, por defecto es regular",
   *  "kind": "both",
   *  "beautifulName": "font"
   * }
   */
  font: _propTypes["default"].oneOf(convertToOptions(BUTTON_FONT)),

  /**
   * {
   *  "info": "Tipo de transformación sobre el texto, por defecto initial",
   *  "kind": "both",
   *  "beautifulName": "textTransform"
   * }
   */
  textTransform: _propTypes["default"].oneOf(convertToOptions(BUTTON_TEXT_TRANSFORM)),

  /**
   * {
   *  "info": "SVG del botón",
   *  "kind": "both",
   *  "beautifulName": "SVG"
   * }
   */
  svgComponent: _propTypes["default"].node,

  /**
   * {
   *  "info": "Tema del botón, sirve para definir el tema del botón en el array BUTTON_COLOR",
   *  "kind": "both",
   *  "beautifulName": "Tema"
   * }
   */
  color: _propTypes["default"].oneOf(convertToOptions(BUTTON_COLOR)),

  /**
   * {
   *  "info": "Permite definir si el botón está desactivado o no; en caso de desactivado el elemento cambiará de color y dejará de ser clicable",
   *  "kind": "both",
   *  "beautifulName": "Habilitado"
   * }
   */
  disable: _propTypes["default"].bool,

  /**
   * {
   *  "info": "Permite definir el tamaño del label, en caso de ser incosistente con su size.h",
   *  "kind": "both",
   *  "beautifulName": "Habilitado"
   * }
   */
  labelSize: _propTypes["default"].oneOf(convertToOptions(LABEL_SIZE)),

  /**
   * {
   *  "info": "Tamaño del botón, permite determinar el tamaño tanto en ancho como en alto {w: BUTTON_WIDTH..., h: BUTTON_HEIGHT...}",
   *  "kind": "both",
   *  "beautifulName": "Tamaño"
   * }
   */
  size: _propTypes["default"].shape({
    /**
     * {
     *  "info": "Permite determinar el ancho del botón",
     *  "kind": "both",
     *  "beautifulName": "Ancho"
     * }
     */
    w: _propTypes["default"].oneOf(convertToOptions(BUTTON_WIDTH)),

    /**
     * {
     *  "info": "Permite determinar la altura del botón",
     *  "kind": "both",
     *  "beautifulName": "Alto"
     * }
     */
    h: _propTypes["default"].oneOf(convertToOptions(BUTTON_HEIGHT))
  }),

  /**
   * {
   *  "info": "Permite establecer una animación en función de un estado a este componente, reflejando una operación de las definidas BUTTON_OPERATION",
   *  "kind": "both",
   *  "beautifulName": "Operacion"
   * }
   */
  operation: _propTypes["default"].oneOf(convertToOptions(BUTTON_OPERATION)),

  /**
   * {
   *  "info": "Url a la que se accederá tras hacer click en el elemento si es que lo tuviese",
   *  "kind": "both",
   *  "beautifulName": "Enlace"
   * }
   */
  link: _propTypes["default"].string,

  /**
   * {
   *  "info": "Función js que se ejecutará al hacer click, si es necesario",
   *  "kind": "playground",
   *  "beautifulName": "Funcion"
   * }
   */
  onClick: _propTypes["default"].func,

  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: _propTypes["default"].object.isRequired,

  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: _propTypes["default"].string,

  /**
   * {
   *  "info": "Define si el enlace se tiene que forzar a comportar como enlace externo",
   *  "kind": "playground",
   *  "beautifulName": "Enlace externo"
   * }
   */
  forceExternal: _propTypes["default"].bool,

  /**
   * {
   *  "info": "Propiedades a aplicar para escritorio (sobreescribe las propiedades anteriores) ",
   *  "kind": "both",
   *  "beautifulName": "Escritorio"
   * }
   */
  desktopProps: _propTypes["default"].object,

  /**
   * {
   *  "info": "Valor del target en caso de tener link",
   *  "kind": "both",
   *  "beautifulName": "Target"
   * }
   */
  target: _propTypes["default"].oneOf(['_self', '_blank', 'parent', '_top']),

  /**
   * {
   *  "info": "Posicion del icono respecto al texto del botón",
   *  "kind": "both",
   *  "beautifulName": "Posición SVG"
   * }
   */
  iconPosition: _propTypes["default"].oneOf(convertToOptions(ICON_POSITION)),

  /**
   * {
   *  "info": "Necesita para especificar el segmento",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  segment: _propTypes["default"].oneOf(convertToOptions(SEGMENT))
};
Button.defaultProps = {
  label: '',
  buttonType: 'button',
  svgComponent: null,
  color: BUTTON_COLOR.GREEN,
  font: BUTTON_FONT.REGULAR_FONT,
  textTransform: BUTTON_TEXT_TRANSFORM.INITIAL,
  disable: false,
  labelSize: null,
  size: {
    w: BUTTON_WIDTH.MEDIUM,
    h: BUTTON_HEIGHT.REGULAR
  },
  operation: BUTTON_OPERATION.NO,
  link: '',
  onClick: null,
  className: '',
  forceExternal: false,
  desktopProps: null,
  target: '_self',
  iconPosition: ICON_POSITION.RIGHT,
  segment: SEGMENT.GP
};
var _default = Button;
exports["default"] = _default;

//# sourceMappingURL=index.js.map